import { render, staticRenderFns } from "./nominateTalk.vue?vue&type=template&id=d915e5e2&scoped=true&"
import script from "./nominateTalk.vue?vue&type=script&lang=js&"
export * from "./nominateTalk.vue?vue&type=script&lang=js&"
import style0 from "./nominateTalk.vue?vue&type=style&index=0&id=d915e5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d915e5e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d915e5e2')) {
      api.createRecord('d915e5e2', component.options)
    } else {
      api.reload('d915e5e2', component.options)
    }
    module.hot.accept("./nominateTalk.vue?vue&type=template&id=d915e5e2&scoped=true&", function () {
      api.rerender('d915e5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/nominateTalk.vue"
export default component.exports